if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.productTemporaryData = [];
      this.ecoPackSellingPlans = {};
      this.subscriptionCartAmountNewState = 0;
      this.cartNotification = document.querySelector('cart-notification');
    }

    async handleDeleteEcoPacksFromCart(products) {
      const cartResponse = await fetchCart();
      const ecoPackCollectionProductIds = ecoPackCollectionItems.map((product) => product.id);
      const ecoPacksInCart = cartResponse.items.filter((product) => ecoPackCollectionProductIds.includes(product.product_id));

      if (Array.isArray(ecoPacksInCart) && ecoPacksInCart.length) {
        this.subscriptionCartAmountNewState = ecoPacksInCart.reduce((previousValue, currentValue) => {
         return previousValue.quantity + currentValue.quantity
        });
      } else {
        this.subscriptionCartAmountNewState = 0
      }

      const sellingPlanIndex = Number(this.subscriptionCartAmountNewState) > 12 ? 11 : (Number(this.subscriptionCartAmountNewState) ? Number(this.subscriptionCartAmountNewState) : 0);
      for (const ecoPackCartItem of ecoPackCollectionItems) {
        const variantId = ecoPackCartItem.variants[0].id;
        const sellingPlan = ecoPackCartItem.selling_plan_groups[0].selling_plans[sellingPlanIndex].id;
        this.ecoPackSellingPlans[variantId] = sellingPlan;
      }
      
      this.productTemporaryData = ecoPacksInCart;

      const updates = {};
      for (const product of products) {
          if (Array.isArray(product.variants) && product.variants.length) {
              updates[product.variants[0].id] = 0;
          } else {
              console.log("Unexpected error product variants is not array");
          };
      }
  
      const response = await updateCart(JSON.stringify({
          updates: updates
      }));
      return response;
    }

    async handleAddEcoPacksToCart(products) {
      const isProductHaveSellingPlan = this.form.querySelector('[name=selling_plan]').getAttribute('value');
      const producuctVariantId = this.form.querySelector('[name=id]').getAttribute('value');
      let body = [];
      const selectedProductInCart = products.filter((product) => product.variant_id === Number(producuctVariantId));
      const isProductExistInCart =  Array.isArray(selectedProductInCart) && selectedProductInCart.length; 

      if (!isProductExistInCart) {
        let bodyItem = {
          id: Number(producuctVariantId),
          quantity: 1
        }
  
        if (isProductHaveSellingPlan) {
          bodyItem.selling_plan =  Number(isProductHaveSellingPlan)
        }
  
        body = [
          bodyItem
        ]
      }

      for (const product of products) {
          const isProductCartDataExist = typeof product === 'object' && product !== null;
          const productCartVariantId = product.variant_id;

          if (!isProductCartDataExist) {
            continue;
          }

          let productInCartQuantity = product.quantity;
          let addToCartDataItem = {
            "id": productCartVariantId,
            "quantity": productCartVariantId === Number(producuctVariantId) ? productInCartQuantity += 1 : productInCartQuantity,
          };
          
          if (isProductHaveSellingPlan) {
            addToCartDataItem.selling_plan = this.ecoPackSellingPlans[productCartVariantId];
          };

          body = [
            ...body,
            addToCartDataItem,
          ];
      }

      await addToCart(JSON.stringify({
        items: body
      }));
    }

    async onSubmitHandler (evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      
/* ADD TO CART FUNCTION */ 
// const config = fetchConfig('javascript');
// config.headers['X-Requested-With'] = 'XMLHttpRequest';
// delete config.headers['Content-Type'];
// const formData = new FormData(this.form);
// formData.append('sections_url', window.location.pathname);
// config.body = formData;
// fetch(`${routes.cart_add_url}`, config)
//   .then((response) => {
//     cartDrawer.openDrawer(cartDrawer.getSelectorTrigger());
//     return response.json();
//   })
//   .then((response) => {
//     if (response.status) {
//       this.handleErrorMessage(response.description);
//       return;
//     }
//   })
//   .catch((e) => {
//     console.error(e);
//   })
//   .finally(() => {
//     submitButton.classList.remove('loading');
//     submitButton.removeAttribute('aria-disabled');
//     this.querySelector('.loading-overlay__spinner').classList.add('hidden');
//   });
/* ADD TO CART FUNCTION END */
    
      try {
        await this.handleDeleteEcoPacksFromCart(ecoPackCollectionItems); 
        await this.handleAddEcoPacksToCart(this.productTemporaryData);
        await cartDrawer.openDrawer(cartDrawer.getSelectorTrigger());
        
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      } catch (err) {
        console.error(err, 'error');
      }
    }

    
    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


window.addEventListener('load', () => {
  const subscriptionCheckbox = document.querySelectorAll('.rc-radio');
  if (!Array.isArray(subscriptionCheckbox) && !subscriptionCheckbox.length) return;

  const membershipCheckbox = document.querySelector('.subscription-radio');
  const productPrice = document.querySelector('.price-item');
  const discountPrice = document.querySelector('.rc-radio__price');
  const discountPriceTag = document.createElement('span');

  discountPriceTag.innerText = discountPrice.innerText;
  productPrice.style.textDecoration = 'line-through';
  discountPriceTag.style.marginRight = '10px';

  productPrice.insertAdjacentElement('beforebegin', discountPriceTag);

  for (const checkbox of subscriptionCheckbox) {
    checkbox.addEventListener('change', () => {
      if (!membershipCheckbox.classList.contains('rc-radio--active')) {
        discountPriceTag.style.display = 'none';
        productPrice.style.textDecoration = 'none';
      } else {
        discountPriceTag.style.marginRight = '10px';
        discountPriceTag.style.display = 'block';
        productPrice.style.textDecoration = 'line-through';
      };
    });
  };
})
